/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_button_view_github = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View on GitHub`)
};

const zh_hans1_button_view_github = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 GitHub 上查看`)
};

const zh_hant1_button_view_github = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 GitHub 上查看`)
};

const fr_button_view_github = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir sur GitHub`)
};

const de_button_view_github = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf GitHub ansehen`)
};

const ja_button_view_github = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub で見る`)
};

const ko_button_view_github = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub에서 보기`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const button_view_github = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.button_view_github(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("button_view_github", locale)
	if (locale === "en") return en_button_view_github(inputs)
	if (locale === "zh-Hans") return zh_hans1_button_view_github(inputs)
	if (locale === "zh-Hant") return zh_hant1_button_view_github(inputs)
	if (locale === "fr") return fr_button_view_github(inputs)
	if (locale === "de") return de_button_view_github(inputs)
	if (locale === "ja") return ja_button_view_github(inputs)
	return ko_button_view_github(inputs)
};